import { Box, Stack, Tab, Tabs } from '@mui/material';
import { DisplayInfo } from 'api/ordering-service/ordering-service.types';
import { SyntheticEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GroupsDisplayContentTab from '../groups-display-content-tab/groups-display-content-tab.component';
import DisplayContentInfo from './display-content-info/display-content-info.component';

type GroupsDisplayContentTabsProps = {
  displayInfos: DisplayInfo[];
};

const GroupsDisplayContentTabs = ({
  displayInfos,
}: GroupsDisplayContentTabsProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);

  const handleChange = (_e: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const languageTitle = useCallback((languageCode: 'EN' | 'ES' | 'FR') => {
    switch (languageCode) {
      case 'EN':
        return 'English';
      case 'ES':
        return 'Spanish';
      case 'FR':
        return 'French';
    }
  }, []);

  return (
    <Box sx={{ width: '100%' }} data-testid="GroupsDisplayContent.Tabs">
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} variant="fullWidth">
          {displayInfos?.map(info => (
            <Tab key={info.langCode} label={languageTitle(info.langCode)} />
          ))}
        </Tabs>
      </Box>
      {displayInfos?.map((info, index: number) => (
        <GroupsDisplayContentTab
          key={info.langCode}
          value={value}
          index={index}
        >
          <DisplayContentInfo
            title={t('drawer.groupsDetailsDrawer.displayContent.title.label')}
            value={info?.title}
            data-testid="Title"
          />
          {info?.shortDescription && (
            <DisplayContentInfo
              title={t(
                'drawer.groupsDetailsDrawer.displayContent.shortDescription.label',
              )}
              value={info.shortDescription}
              data-testid="ShortDescription"
            />
          )}
          {info?.longDescription && (
            <DisplayContentInfo
              title={t(
                'drawer.groupsDetailsDrawer.displayContent.longDescription.label',
              )}
              value={info.longDescription}
              data-testid="LongDescription"
            />
          )}
          <Stack direction="row" spacing={2}>
            {info?.smallImage?.length > 0 && (
              <DisplayContentInfo
                title={t(
                  'drawer.groupsDetailsDrawer.displayContent.smallImage.label',
                )}
                value={info?.smallImage}
                data-testid="SmallImage"
                smallImage
              />
            )}
            {info?.mediumImage?.length > 0 && (
              <DisplayContentInfo
                title={t(
                  'drawer.groupsDetailsDrawer.displayContent.mediumImage.label',
                )}
                value={info?.mediumImage}
                data-testid="MediumImage"
              />
            )}
          </Stack>
        </GroupsDisplayContentTab>
      ))}
    </Box>
  );
};

export default GroupsDisplayContentTabs;
